module.exports = __webpack_public_path__ + "media/public/img/expedia-review-widget-01-6a8748bc8b83530f19f0577495396935.svg";